import React from 'react';
import { unmountComponentAtNode } from 'react-dom';

import renderWithStore from 'state/renderWithStore';
import { getManagedSortModels, ModelContext } from 'features/sort';
import forceDisplayTypeId from 'apps/sortAttributeFilters/forceDisplayTypeId';
import { AppSortAttributeFilters } from 'apps/sortAttributeFilters/desktop';
import { dynamicPersistenceStore } from 'features/sort';

function initFilterDisplaySet () {

	forceDisplayTypeId();

	const className = 'lpForm';
	const managedSortModels = getManagedSortModels();
	const {
		canAttributesMapToFds,
		fdsQueryRulesChoices,
		fdsFacetCanonicalData,
		appliedFilters
	} = lp.pageData.sortFilter;
	
	let cleanups = [];

	managedSortModels.forEach((model) => {

		const {
			AttributeGroups,
			FilterDisplayTypeId,
			DefaultVisibleMenuCount,
			CanonicalOrderedUrlFragments
		} = model;

		const container = document.querySelector(`.setDT-${FilterDisplayTypeId}`);

		if (!container || !AttributeGroups) {

			return;

		}

		unmountComponentAtNode(container);

		renderWithStore(
			<ModelContext.Provider
				value={{
					canAttributesMapToFds,
					fdsQueryRulesChoices,
					CanonicalOrderedUrlFragments,
					fdsFacetCanonicalData,
					setDisplayTypeId: FilterDisplayTypeId
				}}
			>
				<AppSortAttributeFilters
					className={className}
					filterDisplayTypeId={FilterDisplayTypeId}
					defaultVisibleMenuCount={DefaultVisibleMenuCount}
					attributeGroups={AttributeGroups}
					appliedFilters={appliedFilters}
				/>
			</ModelContext.Provider>,
			container,
			dynamicPersistenceStore
		);

		cleanups.push(() => {

			unmountComponentAtNode(container);

		});

	});

	return cleanups;

}

export default initFilterDisplaySet;
